import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { capitalize, envAwarePost, slidingQueryComparision } from '../../util/util'
import Select from 'react-select'
import {
	fetchByTag,
	readTags,
	createRecipe,
	editRecipe,
	deleteDefaultRecipe,
	addRecipeMacros,
	createTag,
	deleteTag,
	addMultipleTagsToRecipe,
	setCopy,
	selectAllRecipes
} from './recipesSlice'
import {useDebounceCallback} from '@react-hook/debounce'
import { useInView } from 'react-intersection-observer'
import DiscussResourceButton from '../DiscussResourceButton/DiscussResourceButton'
import classes from './Recipes.module.css'
import Button from 'react-bootstrap/Button'
import Popover from 'react-bootstrap/Popover'
import Modal from 'react-bootstrap/Modal'
import Col from 'react-bootstrap/Col'
import Carousel from 'react-bootstrap/Carousel'
import Row from 'react-bootstrap/Row'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Form from "react-bootstrap/Form"
import useS3DirectUpload from "../../hooks/useS3DirectUpload"
import useCurrentUser from '../../hooks/useCurrentUser'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import CreatableSelect from 'react-select/creatable';
import { components } from "react-select";
import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'
import GymMultiSelect from '../GymMultiSelect/GymMultiSelect'
import {useHistory} from 'react-router-dom'
import Recipe from './Recipe'
import CopyModal from './CopyModal'
import Editor from './Editor'
import Viewer from './Viewer'

const CatalogRecipe = ({recipe,expand})=>{
	const shortNutrientMap = {
		calories:'cal',
		carbohydrate:'carb',
		protein:'pro',
		fat:'fat'
	}
	return (
		<div
			style={{
				position:'relative',
				cursor:'pointer'
			}}
			onClick={expand}
			className="rounded shadow border overflow-hidden d-flex flex-column"
		>
			<div style={{
				fontSize:'14px',
				fontWeight:600,
				position:'absolute',
				background:'linear-gradient(to bottom, #000,transparent)',
				color:'#fff',
				width:'100%',
				top:0,left:0,
				padding:'8px'
			}}>
				{recipe.recipe_name}
			</div>
			<img 
				src={recipe.recipe_image} 
				className="d-block w-100"
				style={{
					height:'160px',
					objectFit:'cover'
				}}
			/>
			<div 
				className="p-1 px-2 d-flex flex-column" 
				style={{
					flex:'1 1 auto',
					background:'#1c1c1c',
					color:'#fff',
					position:'absolute',
					bottom:0,left:0,
					width:'100%',
					background:'linear-gradient(to top, #000,rgba(0,0,0,0.5))',
				}}
			>
				{/*<div style={{fontSize:'12px'}}>
					{recipe.recipe_types.recipe_type.join(', ')}
				</div>*/}
				<div className="d-flex justify-content-between mt-auto" style={{fontSize:'12px'}}>
					{Object.entries(recipe.recipe_nutrition).map(([nutrient,amount])=>(
						<div className="text-center">
							<div style={{
								color:'#27ba71',
								lineHeight:'14px'
							}}>
								{shortNutrientMap[nutrient]}
							</div>
							<div style={{fontSize:'12px'}}>
								{amount.split('.')[0]}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

const ExpandedRecipe = ({id,hide})=>{
	const fetch = async id => {
		const res = await envAwarePost('api/recipes/', { action: 'getCatalogRecipe',id })
		if (res) setStatus('idle')
		if(res.success==='1'){
			setRecipe(res.data.recipe)
		}else{
			window.alert(res.message)
			hide()
		}
		
	}

	const servingInfo = [
		{key:'serving_size',label:'Serving Size'},
		{key:'calories',label:'Calories'},
		{key:'protein',label:'Protein',unit:'g'},
		{key:'carbohydrate',label:'Carbohydrate',unit:'g'},
		{key:'fiber',label:'Fiber',unit:'g'},
		{key:'sugar',label:'Sugar',unit:'g'},
		{key:'fat',label:'Fat',unit:'g'},
		{key:'saturated_fat',label:'Saturated Fat',unit:'g'},
		{key:'calcium',label:'Calcium',unit:'mg'},
		{key:'cholesterol',label:'Cholesterol',unit:'mg'},
		{key:'iron',label:'Iron',unit:'mg'},
		{key:'monounsaturated_fat',label:'Monounsaturated Fat',unit:'g'},
		{key:'polyunsaturated_fat',label:'Polyunsaturated Fat',unit:'g'},
		{key:'trans_fat',label:'Trans Fat',unit:'g'},
		{key:'potassium',label:'Potassium',unit:'mg'},
		{key:'sodium',label:'Sodium',unit:'mg'},
		{key:'vitamin_a',label:'Vitamin A',unit:'mg'},
		{key:'vitamin_c',label:'Vitamin C',unit:'mg'},
	]

	const [recipe,setRecipe] = useState(false)
	const [status,setStatus] = useState('idle')

	console.log(recipe)

	useEffect(()=>{
		setRecipe(false)
		if (!Boolean(id)) return
		setStatus('pending')
		fetch(id)
	},[id])

	return (
		<Modal show={Boolean(id)} onHide={hide} centered>
			{Boolean(recipe)&&
				<Modal.Header>
					{recipe.recipe_name}
				</Modal.Header>
			}
			<Modal.Body>
				{status==='pending'&&
					<Spinner animation="border"/>
				}
				{(status==='idle'&&Boolean(recipe))&&
					<div>
						<div className="d-flex">
							<div>
								<img 
									style={{
										width:'200px',
										height:'200px',
										borderRadius:'7px',
										overflow:'hidden',
										display:'block',
										objectFit:'cover'
									}}
									src={recipe.recipe_images.recipe_image[0]}
								/>
								<div>
									Type: {recipe.recipe_types.recipe_type.join(', ')}
								</div>
								<div>
									Prep Time: {recipe.preparation_time_min} mins
								</div>
								<div>
									Cooking Time: {recipe.cooking_time_min} mins
								</div>
								<div>
									Servings: {recipe.number_of_servings}
								</div>
							</div>
							<div className="ml-2">
								<strong className="d-block">
									Ingredients
								</strong>
								{recipe.fatsecret_ingredients.ingredient.map(ing=>(
									<div className="mt-1">
										{ing.food.ingredient_description}
									</div>
								))}
							</div>
						</div>
						<hr/>
						<div>
							<strong className="d-block">
								Directions
							</strong>
							{recipe.fatsecret_directions.map((direction,i)=>(
								<div className="mt-1">
									{i+1}) {direction.direction_description}
								</div>
							))}
						</div>
						<hr/>
						<div>
							<strong className="d-block">
								Nutrition Info
							</strong>
							{servingInfo.map(({key,label,unit=''})=>(
								<div style={{borderTop:'1px solid #000',display:'flex'}}>
									{label} <div className="ml-auto">{recipe.serving_sizes.serving[key]}{Boolean(unit)&&` ${unit}`}</div>
								</div>
							))}
						</div>
					</div>
				}
			</Modal.Body>
		</Modal>
	)
}

const Catalog = ({searchQuery})=>{
	const [recipes,setRecipes] = useState([])

	const search = async query => {
		setStatus('pending')
		const res = await envAwarePost('api/recipes/', { action: 'searchRecipeCatalog',query })
		if(res) setStatus('idle')
		if ( res.success === '1') {
			setRecipes(res.data.recipes)
		}
		else{
			window.alert(res.message)
		}
	}

	console.log(recipes)

	const debouncedSearch = useDebounceCallback(search,400)

	const [status,setStatus] = useState('idle')

	const [expandedRecipeId,setExpandedRecipeId] = useState(false)

	useEffect(()=>{
		if (!searchQuery) return 
		debouncedSearch(searchQuery)
	},[searchQuery])

	return (
		<div style={{
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fit,minmax(min(180px,100%),1fr))',
			gridGap: '16px'
		}}>
			{status==='pending'&&<Spinner animation="border"/>}

			{(status==='idle'&&Boolean(recipes.length))&&
				recipes.map(recipe=>
					<CatalogRecipe 
						key={recipe.recipe_id} 
						recipe={recipe} 
						expand={setExpandedRecipeId.bind(null,recipe.recipe_id)}
					/>
				)
			}

			{(status==='idle'&&!recipes.length)&&
				'Search for a recipe using the input above'
			}

			<ExpandedRecipe 
				id={expandedRecipeId} 
				hide={setExpandedRecipeId.bind(null,false)}
			/>
		</div>
	)
}

const Recipes = props => {
	const urlParams = new URLSearchParams(window.location.search)
	const [filterId,setFilterId] = useState(
		parseInt(
			urlParams.get('recipe_id')
		)
	)
	const trainer = urlParams.get('trainer')
	const trainerParam = (
		Boolean(trainer)
		? `&trainer=${trainer}`
		: ''
	)
	const history = useHistory()
	const status = useSelector(state => state.recipes.status)
	const recipes = useSelector(selectAllRecipes)
	const owners = useSelector(state=>state.recipes.owners)

	
	const isClient = useSelector(state => state.users.current_user.account_type) === "client"
	const user = useCurrentUser()
	const isTrainer = user.account_type === 'trainer'
	const isGym = user.account_type === 'gym'
	const isChain = user.account_type === 'chain'
	const isGymOrTrainer = user.account_type === 'trainer' || user.account_type === "gym"

	const [ownerFilter, setOwnerFilter] = useState(
		isChain?user.user_id_number:'all'
	)

	const isPartOfGym = user.gym_id != 0
	const [tagFilters, setTagfilters] = useState([])
	const [chosenTags, setChosenTags] = useState([])

	const tags = useSelector(state => state.recipes.tags)

	const dispatch = useDispatch()

	//Modal 
	const [show, setShow] = useState(false);
	const [modalRecipe, setModalRecipe] = useState({})
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	//add recipe
	const [recipeName, setRecipeName] = useState("")
	const [recipeDescription, setRecipeDescription] = useState("")
	const [recipeDetails, setRecipeDetails] = useState("")
	const [recipeLink, setRecipeLink] = useState("")
	const [recipeImage, setRecipeImage] = useState("")
	const [recipeAddIns, setRecipeAddIns] = useState("")
	const [recipeIngredients, setRecipeIngredients] = useState("")
	const [recipeServingSize, setRecipeServingSize] = useState("")
	const [recipeNumServings, setRecipeNumServings] = useState("")
	const [addModalShow, setAddModalShow] = useState(false)
	const [editModalShow, setEditModalShow] = useState(false)
	const [editRecipeId, setEditRecipeId] = useState("")
	const [imageUploading, setImageUploading] = useState(false)
	const [macroForms, setmacroForms] = useState([
		{ 'macro': 'Calories', 'qty': 0, 'unit': "Cal", 'id': '1a' },
		{ 'macro': 'Fat', 'qty': 0, 'unit': "g", 'id': '2a' },
		{ 'macro': 'Carbs', 'qty': 0, 'unit': "g", 'id': '3a' },
		{ 'macro': 'Protein', 'qty': 0, 'unit': "g", 'id': '4a' }
	])
	const [showAddMacro, setShowAddMacro] = useState(false)
	const [showAddTag, setShowAddTag] = useState(false)
	const [newTag, setNewTag] = useState("")

	const [newMacro, setNewMacro] = useState("")
	const [macroUnit, setMacroUnit] = useState("")

	const [isLoading, setIsLoading] = useState(false)
	// setNewMacro 
	const [searchQuery, setSearchQuery] = useState("")

	const [addEditMacros, setAddEditMacros] = useState(false)
	const [isNewTagLoading, setIsNewTagLoading] = useState(false)
	const [isDeleteLoading, setIsDeleteLoading] = useState(false)
	const statusDispatch = useApiStatusDispatch()
	const {
		file: upload,
		processUpload,
		setUpload,
		clearUpload
	} = useS3DirectUpload()

	const [isTagLoading, setIsTagLoading] = useState(false)

	//current options: custom/catalog
	const [recipeList,setRecipeList] = useState('custom')

	useEffect(() => {
		dispatch(fetchByTag({ 
			owner_id:ownerFilter,
			limit:300,
			offset:0,
			tags: tagFilters 
		}))

		setIsTagLoading(true)
		dispatch(readTags({ action: 'readTags' }))
			.then(res => setIsTagLoading(false))

	}, [])

	//list of gyms for corporate account
	const [gyms, setGyms] = useState([])

	useEffect(() => {
		envAwarePost('api/users/', { action: 'getAllGyms' }).then( res => {
			setGyms(res.data)
		})
	}, [])

	const handleAddRecipe = (e) => {
		setIsLoading(true)
		let payload = {
			action: "createRecipe",
			name: 'Untitled Recipe',
			description: '',
			directions: '',
			link: '',
			image: '',
			ingredients: '',
			add_ins: '',
			serving_size: 0,
			num_servings: 0
		}


		dispatch(createRecipe(payload)).then((res) => {
			setIsLoading(false)
			const {id} = res.payload.data;
			history.push(`/recipe-editor?id=${id}${trainerParam}`)
		})
	}

	const handleDeleteRecipe = (id) => {
		const payload = {
			action: "deleteDefaultRecipe",
			recipe_id: id
		}
		setIsDeleteLoading(true);
		statusDispatch(deleteDefaultRecipe(payload), "recipe", "delete").then(() => {
			setShow(false)
			setIsDeleteLoading(false);
			dispatch(fetchByTag({ action: 'readRecipes', tags: tagFilters }))
		})
	}

	const checkTagPermission = (tag) => {
		// if not trainer associated with gym or is Gym can always delete tag
		if ((isTrainer && !isPartOfGym) || isGym) return true;
		// gym trainer cannot delete gym tags
		return tag.owner_type === "gym" ? false : true
	}

	const processTagsMatch = (recipe) => {
		//assume tag match
		let tagMatch = true;

		// check if tag filtering is happening
		if (tagFilters.length > 0) {
			let recipeTagsMatch = recipe?.tags?.filter(tag => {
				return tagFilters.includes(tag.id)
			})
			// update tagMatch boolean
			tagMatch = recipeTagsMatch.length === tagFilters.length
		}

		return tagMatch;
	}

	const processSearchMatch = (recipe) => {
		// assume searchMatch = true;
		let searchMatch = true;

		// if a search has been entered
		if (Boolean(searchQuery)) {
			let recipeName = recipe?.name?.toLowerCase()
			let searchCleaned = searchQuery.toLowerCase()

			// assume no tag match
			let recipeSearchTagMatch = false;

			// check if recipe tags exists on current recipe
			if (recipe?.tags?.length > 0) {
				let tagNames = recipe?.tags?.map(tag => tag.name.toLowerCase())
				// check if search matched a recipe tag name
				recipeSearchTagMatch = tagNames.includes(searchCleaned)
			}

			// check if search matched a recipe name
			let searchNameMatch = recipeName.includes(searchCleaned)

			// if a recipe tag or recipe name has been matched return true
			searchMatch = recipeSearchTagMatch || searchNameMatch
		}

		return searchMatch;
	}

	const recipeSearchFilter = (recipe) => {
		let tagMatch = processTagsMatch(recipe)

		return tagMatch 
	}

	function handleAddTag(tagName) {
		setIsNewTagLoading(true);
		statusDispatch(createTag({ action: "createTag", name: tagName }), "tag", "create")
			.then((res) => {
				setIsNewTagLoading(false);
				setNewTag("");
			}
			)
	}

	function handleCreateTag(tagName) {
		setIsNewTagLoading(true);
		dispatch(createTag({ action: "createTag", name: tagName }))
			.then((res) => {
				if (res.payload.success == "1") {
					let newTag = res.payload.data;
					setChosenTags(prev => ([...prev, { label: newTag.name, value: newTag.id }]))
					setIsNewTagLoading(false);
				}
			})
		//setChosenTags(prev=> ( {...prev, label:item.name,value:item.id }))
	}

	const [isSearching,setIsSearching] = useState(false)

	const debouncedRecipeSeaerch = useDebounceCallback((pattern)=>{
		dispatch(fetchByTag({ 
			owner_id:(
				ownerFilter==='all'
				? 'all'
				: ownerFilter
			),
			limit:blockSize,
			offset:0,
			tags: tagFilters,
			clear:true,
			pattern
		}))
	},500)

	const handleSearchQuery = (e) => {
		//we use the API that integrates with FatSecret to search the catalog
		setSearchQuery(e.target.value)
		if (recipeList==='catalog') return 
		debouncedRecipeSeaerch(e.target.value)
	}

	function handleTagFilters(tag) {
		if (tagFilters.includes(tag.id)) {
			setTagfilters(tagFilters.filter(id => id !== tag.id))
		} else {
			setTagfilters([...tagFilters, tag.id])
		}
	}

	function handleTagDelete(tag) {
		if (window.confirm("Are you sure you would like to permanently delete this tag?")) {
			statusDispatch(deleteTag({ action: "deleteTag", tag_id: tag.id }), "tag", "delete")
				.then(res => {
					setTagfilters([])
					dispatch(readTags({ action: 'readTags' }))
					dispatch(fetchByTag({ action: 'readRecipes', tags: [] }))
				})
		}
	}

	const [showDelete, setShowDelete] = useState(false);
	const tagsPopover = (
		<Popover id="tag-filters" >
			<Popover.Content>
				<div>
					{!isClient && <OverlayTrigger
						placement="right"
						overlay={
							<Tooltip>
								Delete Tags
							</Tooltip>
						}>
						<div className=" ml-1 float-right">
							<i style={{ "cursor": "pointer" }}
								onClick={() => setShowDelete(prev => !prev)}
								className="fas fa-cog" />
						</div>
					</OverlayTrigger>}
					{tags.length > 0 ?
						tags.map(tag => (
							<div style={{ display: "inline-block", position: "relative" }}>
								{showDelete && checkTagPermission(tag) &&

									<span onClick={() => { handleTagDelete(tag) }} className={classes.tagDelete}> x </span>}
								<span style={{ cursor: "pointer" }}
									className={[
										classes.Tag,
										tagFilters.includes(tag.id) ? classes.Active : ''
									].join(' ')}
									onClick={() => {
										handleTagFilters(tag);

									}}>
									{tag.name}
								</span>
							</div>

						))
						:
						<div>No tags found</div>
					}
				</div>
			</Popover.Content>
		</Popover>
	)

	const { ref: scrollRef, inView } = useInView({
		/* Optional options */
		threshold: 0,
	})

	const blockSize = 100
	const [currentBlock,setCurrentBlock] = useState(1)
	const [showInfiniteScrollSpinner,setShowInfiniteScrollSpinner] = useState(false)
	const displayCount = currentBlock*blockSize

	const filteredRecipes = useMemo(
		() => recipes.filter( r => {
			//matches selected account (for chains only)
			return (
				//matches owner type
				(ownerFilter === 'all' || parseInt(r.owner_id) === parseInt(ownerFilter)) &&
				//matches search filter
				recipeSearchFilter(r)
			)
		}),
		[ownerFilter, recipes, searchQuery, tagFilters]
	)

	useEffect(() => {
		if (inView) {
			setShowInfiniteScrollSpinner(true)
			dispatch(fetchByTag({ 
				owner_id:(
					ownerFilter==='all'
					? 'all'
					: ownerFilter
				),
				limit:blockSize,
				offset:filteredRecipes.length,
				loadInBackground:true,
				tags: tagFilters,
				pattern:searchQuery
			})).then(()=>{
				setShowInfiniteScrollSpinner(false)
			})
			setCurrentBlock(p=>p+1)
		}
	}, [inView])

	return (
		<div className={classes.Recipes} id="containerDiv">
			<div className="d-flex align-items-center flex-wrap">
				<div className="w-50">
					<div className="input-group">
						<div className="input-group-prepend">
							<select 
								className="input-group-text" 
								value={recipeList}
								onChange={e=>{
									setRecipeList(e.target.value)
								}}
							>
								<option value="custom">My Recipes</option>
								<option value="catalog">Recipe Catalog</option>
							</select>
						</div>
						<Form.Control
							style={{maxWidth:'600px'}}
							onChange={handleSearchQuery}
							value={searchQuery}
							placeholder="search recipes"
						/> 
					</div>
					<small>
						NEW: Recipe Catalog <a href="https://www.fatsecret.com">
    <img src="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret.png" srcset="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_2x.png 2x, https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_3x.png 3x" border="0"/>
</a>
					</small>
				</div>
				<div className="ml-auto d-flex align-items-center mt-1">
					{recipeList==='custom'&&
						<OverlayTrigger
							rootClose
							placement="right"
							trigger="click"
							overlay={tagsPopover}>
							<Button className={[classes.tagsPopoverBtn,'mr-1'].join(' ')}>
								<i class="fas fa-sliders-h"></i>
							</Button>
						</OverlayTrigger>
					}
					{/*The only ppl that should see this select are gym trainers or chain account*/}
					{(((isTrainer&&isPartOfGym) || isChain || isClient)&&recipeList==='custom') &&
						<Form.Control
							style={{ "width": "160px" }}
							className="py-2"
							onChange={e => { 
								//reset pagiination
								setCurrentBlock(1)
								setOwnerFilter(e.target.value) 
							}}
							value={ownerFilter}
							as="select"
						>
							{!isChain&&<option value="all">All</option>}
							{owners.map( o => (
								<option value={o.user_id_number}>
									{
										isChain
										? o.user_name
										: `${o==='MAX'?'MAX':'My'} ${user.account_type === o.account_type || o.account_type === 'MAX'? '' : ` ${capitalize(o.account_type)}'s `} recipes`
									}
								</option>
							))}
						</Form.Control>
					}

					{recipeList==='custom'&&
						<div size="sm" style={{flex:'0 0 auto'}}>
							<Button
								disabled={isLoading}
								variant="outline-success"
								onClick={handleAddRecipe}
								style={{ flex: '0 0 auto' }}
								className="ml-1"
							>
								Add Recipe {isLoading&&<Spinner animation="border" size="sm"/>}
							</Button>
						</div>
					}

					{Boolean(filterId)&&
						<div className="mb-2">
							Viewing filtered list: 
							<Button 
								onClick={()=>{ 
									setFilterId(false)
									history.replace('/recipeList/')
								}}
								variant="outline-danger" 
								className="ml-2"
								size="sm"
							>
								Clear Filters
							</Button>
						</div>
					}
				</div>
			</div>
			{recipeList==='catalog'&&
				<Catalog searchQuery={searchQuery}/>
			}
			{recipeList==='custom'&&
				<div className={classes.RecipeList}>
					{
						status === "pending" ?
							<div className="d-flex justify-content-center flex-column">
								<Spinner animation="border" role="status">
									<span className="sr-only">Loading...</span>
								</Spinner>
							</div>
							:
							(
								recipes.length 
									? (
										<>
											{filteredRecipes
												.filter(r=>!Boolean(filterId)||r.id===filterId)
												.slice(0,displayCount)
												.map( 
													recipe => (
														<Recipe 
															key={recipe.id} 
															recipe={recipe}
														/>
													)
												)//end map
											}
											<div ref={scrollRef}>
												{showInfiniteScrollSpinner&&
													<>
														Checking for more recipes <Spinner animation="border" size="sm"/>
													</>
												}
											</div>
										</>
									) : (
										<div style={{
											height: '100vh',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											flexFlow: 'column'
										}}>
											<strong>No results</strong>
										</div>
									)
							)
					}
				</div>
			}
			

			
			<Viewer/>
			<CopyModal />
		</div>
	)
}

export default Recipes